import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RefundPolicyService } from '../../../services/Cancellation.service';
import { exceptionType, ListData, ListFilter, policyType, Reservation } from '../../../models/List.Cancellation';
import { CancellationFormComponent } from './components/cancellation-form/cancellation-form.component';
import { ExceptionRuleGuestsTagsComponent } from './components/exception-rule-guests-tags/exception-rule-guests-tags.component';
import { ExceptionRuleReservationComponent } from './components/exception-rule-reservation/exception-rule-reservation.component';
import { ShowPolicyComponent } from './components/show-policy/show-policy.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cancellation',
  templateUrl: './cancellation.component.html'
})
export class CancellationComponent implements OnInit {
  dataLoading = false;
  recordsData!: ListData | null;
  filterModel: ListFilter = new ListFilter();
  pageIndex = 0;
  pageCount = 0;
  // Restaurant ID
  restaurantId?: any;

  policyAmount: any;

  exceptionReservationNumber!: Reservation | null;
  exceptionTags: any
  SelectedTags = []

  // Manager Permission
  @Input() canViewCancellationPolicy!: boolean;
  @Input() canAddCancellationPolicy!: boolean;
  @Input() canEditCancellationPolicy!: boolean;
  @Input() canDeleteCancellationPolicy!: boolean;

  subscriptions: Subscription[] = []

  constructor(public dialog: MatDialog, private route: ActivatedRoute, private service: RefundPolicyService,
    private translate: TranslateService) {
    this.route.params.subscribe(params => {
      this.restaurantId = params['id'];
    });
  }

  ngOnInit(): void {
    this.getAllCancellation(null);
    this.subscriptions.push(
      this.service.refreshList.subscribe(data => {
        if (data) {
          this.getAllCancellation(null);
        }
      })
    )
    this.getNoShowPolicy();
    this.GetExceptionReservationNumber();
    this.GetExceptionTags();
  }

  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  addCancellationPolicy(record: any | null = null) {
    const dialogRef = this.dialog.open(CancellationFormComponent, {
      width: '50rem',
      data: { record, restaurantsId: this.restaurantId, id: record }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllCancellation(this.filterModel.pageNumber);
      }
    });
  }


  editShowPolicy(amount?: any) {
    const dialogRef = this.dialog.open(ShowPolicyComponent, {
      width: '460px',
      data: { amount, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getNoShowPolicy();
      }
    });
  }

  counter(i: number) { return new Array(i); }

  getAllCancellation(event: any) {
    this.dataLoading = true;
    if (event) {
      this.pageIndex = event;
    } else {
      this.pageIndex = 0;
    }
    this.filterModel.pageSize = 4;
    this.filterModel.pageNumber = this.pageIndex;
    this.filterModel.restaurantId = this.restaurantId;

    this.service.getPolicies(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data;
          this.pageCount = Math.ceil(this.recordsData.cancellationPolicies.totalCount / this.filterModel.pageSize);

        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });
  }

  getNoShowPolicy() {
    this.service.GetNoShowPolicy(this.restaurantId).subscribe((data: any) => {
      this.policyAmount = data.refund;
    })
  }

  GetExceptionReservationNumber() {
    this.service.GetExceptionReservationNumber(this.restaurantId).subscribe((data: Reservation) => {
      this.exceptionReservationNumber = data
    })
  }

  exceptionRuleForReservation(reservationNumber?: any) {
    const dialogRef = this.dialog.open(ExceptionRuleReservationComponent, {
      width: '460px',
      data: { reservationNumber, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.GetExceptionReservationNumber();
      }
    });
  }

  GetExceptionTags() {
    this.service.GetExceptionTags(this.restaurantId).subscribe((data: any) => {
      this.exceptionTags = data;
    })
  }
  exceptionRuleForGuestsTags() {
    const dialogRef = this.dialog.open(ExceptionRuleGuestsTagsComponent, {
      width: '460px',
      data: {exceptionTags: this.exceptionTags, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.GetExceptionTags();
      }
    });
  }


  deleteCancellationRecord(recordId: any) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.delete(recordId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              if (this.recordsData?.cancellationPolicies?.pageData?.length == 1) {
                this.filterModel.pageNumber > 0 ? this.filterModel.pageNumber -= 1 : this.filterModel.pageNumber
              }
              if (this.filterModel.pageNumber == this.pageIndex) {
                this.pageIndex = this.filterModel.pageNumber;
                this.getAllCancellation(this.filterModel.pageNumber);
              } else {
                this.getAllCancellation(this.filterModel.pageNumber);
              }

              // if (this.recordsData?.cancellationPolicies?.pageData?.length == 1) {
              //   this.filterModel.pageNumber = this.filterModel.pageNumber - 1
              //   this.getAllCancellation(this.filterModel.pageNumber);
              // }
              // else if (this.filterModel.pageNumber == 0) {
              //   this.getAllCancellation(0);
              // }
              // else {
              //   this.filterModel.pageNumber = this.filterModel.pageNumber
              //   this.getAllCancellation(this.filterModel.pageNumber);
              // }
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }

  changeCancellationPolicyStatus(id?: any, isActive?: boolean) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        // id: number, Status: boolean, restaurantId?: number, policyType?: string
        this.service.ChangePolicyStatus(id, isActive, this.restaurantId, policyType.CancellationPolicy).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.updatedsuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAllCancellation(null);
            }
          }),
          (error: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          }
      }
    });
  }

  changeShowPolicyStatus(id?: any, isActive?: boolean) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        // id: number, Status: boolean, restaurantId?: number, policyType?: string
        this.service.ChangePolicyStatus(id, isActive, this.restaurantId, policyType.No_Show).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.updatedsuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAllCancellation(null);
            }
          },
          (error: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          })
      }
    });
  }

  changeExceptionReservationStatus(isActive?: boolean) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        // id: number, Status: boolean, restaurantId?: number, policyType?: string
        this.service.ChangeExceptionsStatus(isActive, this.restaurantId, exceptionType.ReservationNumber).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.updatedsuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAllCancellation(null);
            }
          },
          (error: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          })
      }
    });
  }

  changeExceptionTagStatus(isActive?: boolean) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        // id: number, Status: boolean, restaurantId?: number, policyType?: string
        this.service.ChangeExceptionsStatus(isActive, this.restaurantId, exceptionType.Tags).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.updatedsuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAllCancellation(null);
            }
          },
          (error: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          })
      }
    });
  }
}
